export default "__VITE_ASSET__e92ba03c__"